import ReactIco from "./Assets/Icons/ReactIco";

import MuiIco from "./Assets/Icons/MuiIco";
import FirebaseIco from "./Assets/Icons/FirebaseIco";
import DeployIco from "./Assets/Icons/DeployIco";
import TypescriptIco from "./Assets/Icons/TypescriptIco";
import NodejsIco from "./Assets/Icons/NodejsIco";
import ExpressIco from "./Assets/Icons/ExpressIco";
import EthersIco from "./Assets/Icons/EthersIco";
import SolidityIco from "./Assets/Icons/SolidityIco";
import NestjsIco from "./Assets/Icons/NestjsIco";
import GeminiIco from "./Assets/Icons/GeminiIco";
import TailwindIco from "./Assets/Icons/TailwindIco";

export const services = [
  {
    Icon: ReactIco,
    heading: "REACT JS",
    description: `ReactJS allows us to build dynamic and interactive web apps with ease. It's fast, scalable, flexible, powerful, 
     and has a robust developer community that's rapidly growing.`,
  },
  {
    Icon: MuiIco,
    heading: "MATERIAL UI",
    description: `Material-UI is a simple and customizable component library to build faster, beautiful, and more accessible React applications.`,
  },
  {
    Icon: TailwindIco,
    heading: "Tailwind CSS",
    description: `Tailwind CSS is a utility-first CSS framework for rapidly building custom user interfaces.`,
  },
  {
    Icon: NodejsIco,
    heading: "Node JS",
    description: `Node.js is an open-source, cross-platform, back-end JavaScript runtime environment that runs on the V8 engine and executes JavaScript code outside a web browser.`,
  },
  {
    Icon: NestjsIco,
    heading: "Nest JS",
    description: `NestJS is a framework for building server-side applications. It is built on top of Node.js and Express.js and is a great choice for building scalable and maintainable applications.`,
  },
  {
    Icon: FirebaseIco,
    heading: "FIREBASE",
    description: `Firebase provides serverless architecture with many services including authentication, storage, database, cloud functions etc.`,
  },
  {
    Icon: DeployIco,
    heading: "DEPLOYMENT",
    description: `Deploy Apps to Gcloud, FlyIO, AWS, Vercel, Netlify, Heroku, Firebase and more.`,
  },
  {
    Icon: TypescriptIco,
    heading: "Typescript",
    description: `Typescript is a strongly typed language a superset of JavaScript that compiles to plain JavaScript.`,
  },
  {
    Icon: ExpressIco,
    heading: "Express",
    description: `Express, is a back end web application framework for Node.js. It is designed for building web applications and APIs. It is industry standard.`,
  },
  {
    Icon: EthersIco,
    heading: "Viem/Ethers",
    description: `The viem and ethers.js library aims to be a complete and compact library for interacting with the Ethereum Blockchain and its ecosystem`,
  },
  {
    Icon: SolidityIco,
    heading: "Solidity",
    description: `Solidity is an object-oriented programming language for implementing smart contracts on various blockchain platforms, most notably, Ethereum.`,
  },
  {
    Icon: GeminiIco,
    heading: "Google Agent Development Kit",
    description: `The Google Agent Development Kit is a tool for developing and deploying agentic applications.`,
  },
];

export const skills = [
  {
    title: "HTML/CSS",
    value: 90,
  },
  {
    title: "REACT JS",
    value: 90,
  },
  {
    title: "Google Agent Development Kit",
    value: 90,
  },
  {
    title: "Tailwind",
    value: 80,
  },
  {
    title: "MUI 5",
    value: 95,
  },
  {
    title: "FIREBASE",
    value: 90,
  },
  {
    title: "3rd PARTY APIs",
    value: 80,
  },
  {
    title: "Node JS",
    value: 90,
  },
  {
    title: "Mongo DB",
    value: 90,
  },
  {
    title: "Socket IO",
    value: 80,
  },
  {
    title: "Typescript",
    value: 90,
  },
  {
    title: "Webpack/Rollup",
    value: 80,
  },
  {
    title: "Chrome Extension Development",
    value: 80,
  },
  {
    title: "CICD Deployments",
    value: 80,
  },
  {
    title: "Gcloud Basics",
    value: 80,
  },
  {
    title: "Elastic Beanstalk",
    value: 80,
  },
  {
    title: "Azure VM",
    value: 70,
  },
  {
    title: "Solidity Development",
    value: 70,
  },
  {
    title: "Etherium Contract Deployment",
    value: 80,
  },
  {
    title: "Subgraph",
    value: 90,
  },
];

export const education = [
  {
    title: "University of Karachi",
    subTitle: "BS:SE - 2019 to 2023",
    para: "Bachelors in Software Engineering from UBIT Karachi University.",
  },
  {
    title: "Adamjee Govt Sci College",
    subTitle: "Intermediate - 2016 to 2018",
    para: "Intermediate passed with A grade, from the top college.",
  },
  {
    title: "School",
    subTitle: "Matric - 2014 to 2016",
    para: "Matric SSC passed with A+ grade, with various congratulating certificates.",
  },
];

export const experience = [
  {
    title: "Fullstack Web3 Developer at Permission",
    subTitle: "2025 to current",
    para: `Role: Fullstack Web3 Developer, I am responsible for developing and maintaining the entire web3 featureset for Permission including but not
    limited to LayerZero Omni Chain Token, Web3 Withdrawal Service, and more.
    While working with the UI, Backend, Extension and Ai Development (GOOGLE ADK) on various applications for Permission.`,
  },
  {
    title: "Senior Frontend Dev at Dechains",
    subTitle: "2021 to 2024",
    para: `Role: Senior Frontend Developer, I was responsible for creating whole responsive
    frontend of various blockchain related apps like NFT Markeplaces etc. While integrating
    and working on modularized custom libraries for apis and blockchain communication,
    Libs being compiled with webpack and rollup`,
  },
  {
    title: "Frontend Dev at Slectus(US)",
    subTitle: "2020 to 2021",
    para: `Multivendor ecommerce style platform with commision support and a complex profile
    and product management system and realtime features, MERN Stack App.
    Role: Frontend Developer, responsible for all the frontend work and integrations on the
    platform, little backend development authorized.`,
  },
  {
    title: "Frontend Dev at Novasoft",
    subTitle: "2020 to 2020",
    para: "Working as a frontend react developer at a software house named Novasoft.",
  },
  {
    title: "Freelancing",
    subTitle: "2019 to current",
    para: "Worked on various projects web based and windows in JAVA C# C++ Python...",
  },
  {
    title: "Graphics Designing at AlRaheem Printing",
    subTitle: "2018",
    para: "1 Year graphics designing at Al-Raheem Printing Services.",
  },
];

export const testimonials = [
  {
    title: "abdul_rafay_ (PK)",
    subTitle: "5 Star at Fiverr",
    para: `Saqlain is an expert react developer, experienced in building beautiful UI, 
    fast delivery and clean code, I am extremely satisfied with the work and I highly 
    recommend him. Will definitely work with him again.`,
  },
  {
    title: "jesusalc (GR)",
    subTitle: "5 Star at Fiverr",
    para: `Good communication, if he does not know, he will figure out and participate together. 
    Good asking questions. Good idea for design.`,
  },
  {
    title: "style2u (CR)",
    subTitle: "5 Star at Fiverr",
    para: `I am highly recommend on Saqlan as a profession to work with I know I will use his service again`,
  },
  {
    title: "perecodina (US)",
    subTitle: "5 Star Review on Fiverr",
    para: "Great experience. Really recommend working with this Seller.",
  },
];

export const portfolio = [
  {
    titleImg: require("src/Assets/Images/Projects/PitchFi/1.jpg").default,
    title: "PitchFi",
    para: `PitchFi is a platform for crowdfunding projects with crypto and fiat support. Unlimited Campaigns and milestones with multi token mutichain support.`,
    link: "https://pitchfi.io",
    imgs: [
      require("src/Assets/Images/Projects/PitchFi/1.jpg").default,
      require("src/Assets/Images/Projects/PitchFi/2.jpg").default,
      require("src/Assets/Images/Projects/PitchFi/3.jpg").default,
      require("src/Assets/Images/Projects/PitchFi/4.jpg").default,
      require("src/Assets/Images/Projects/PitchFi/5.jpg").default,
      require("src/Assets/Images/Projects/PitchFi/6.jpg").default,
    ],
  },
  {
    titleImg: require("src/Assets/Images/Projects/PmpyWalletExtension/1.jpg").default,
    title: "Pmpy Chrome/Mobile Defi Wallet",
    para: `Non custodial crypto ethereum wallet chrome extension, competitor of Metamask. Full functionality with creating wallets to importing seeds, sending, receiving, and more with ability to connect with dApps.Chrome Extension as well as cross platform react native mobile app.`,
    imgs: [
      require("src/Assets/Images/Projects/PmpyWalletExtension/1.jpg").default,
      require("src/Assets/Images/Projects/PmpyWalletExtension/2.jpg").default,
      require("src/Assets/Images/Projects/PmpyWalletExtension/3.jpg").default,
      require("src/Assets/Images/Projects/PmpyWalletExtension/4.jpg").default,
      require("src/Assets/Images/Projects/PmpyWalletExtension/5.jpg").default,
      require("src/Assets/Images/Projects/PmpyWalletExtension/6.jpg").default,
      require("src/Assets/Images/Projects/PmpyWalletExtension/7.jpg").default,
      require("src/Assets/Images/Projects/PmpyWalletExtension/8.jpg").default,
      require("src/Assets/Images/Projects/PmpyWalletExtension/9.jpg").default,
      require("src/Assets/Images/Projects/PmpyWalletExtension/10.jpg").default,
    ],
  },
  {
    titleImg: require("src/Assets/Images/Projects/Contrax/1.jpg").default,
    title: "Contrax Finance",
    para: `Non custodial crypto yield farming aggregator platform with eth zapping and social logins, With extra features like swapping onramp offramp bridges and more... Built with React JS, Web3/Ethers, Subgraph, Solidity, Webpack, Typescript, CICD Deployments, Etherium Smart Contracts, 3rd Party APIs, etc...`,
    link: "https://beta.contrax.finance",
    imgs: [
      require("src/Assets/Images/Projects/Contrax/1.jpg").default,
      require("src/Assets/Images/Projects/Contrax/2.jpg").default,
      require("src/Assets/Images/Projects/Contrax/3.jpg").default,
      require("src/Assets/Images/Projects/Contrax/4.jpg").default,
      require("src/Assets/Images/Projects/Contrax/5.jpg").default,
      require("src/Assets/Images/Projects/Contrax/6.jpg").default,
      require("src/Assets/Images/Projects/Contrax/7.jpg").default,
      require("src/Assets/Images/Projects/Contrax/8.jpg").default,
      require("src/Assets/Images/Projects/Contrax/9.jpg").default,
    ],
  },
  {
    titleImg: require("src/Assets/Images/Projects/Chailabs/1.jpg").default,
    title: "Chailabs",
    para: `A decentralized chat app with communities and DAOs, having proposals with onchain and offchain decentralized organizations.`,
    link: "https://chailabs-chat.vercel.app",
    imgs: [
      require("src/Assets/Images/Projects/Chailabs/1.jpg").default,
      require("src/Assets/Images/Projects/Chailabs/2.jpg").default,
      require("src/Assets/Images/Projects/Chailabs/3.jpg").default,
      require("src/Assets/Images/Projects/Chailabs/4.jpg").default,
      require("src/Assets/Images/Projects/Chailabs/5.jpg").default,
    ],
  },
  {
    titleImg: require("src/Assets/Images/Projects/FroggoDashboard/1.jpg").default,
    title: "Mutant Froggo Dashboard",
    para: `A Complete dApp with minting and Nfts management system, with a complete dashboard. Ethers Smart Contracts and React Queries with The Graph.`,
    link: "https://www.dashboard.mutantfroggo.com",
    imgs: [
      require("src/Assets/Images/Projects/FroggoDashboard/1.jpg").default,
      require("src/Assets/Images/Projects/FroggoDashboard/2.jpg").default,
      require("src/Assets/Images/Projects/FroggoDashboard/3.jpg").default,
      require("src/Assets/Images/Projects/FroggoDashboard/4.jpg").default,
      require("src/Assets/Images/Projects/FroggoDashboard/5.jpg").default,
    ],
  },
  {
    titleImg: require("src/Assets/Images/Projects/GameAntz/1.jpg").default,
    title: "GameAntz",
    para: `GameAntz is a newly conceptualized ecosystem joining crypto descentralized environment with a centralized MMORPG dApp allowing holders to trade in DEX/CEX and battle in private Missions for a prize in tokens (tradable in full once transferred back to wallet)`,
    link: "https://gameantz.com/",
    imgs: [
      require("src/Assets/Images/Projects/GameAntz/1.jpg").default,
      require("src/Assets/Images/Projects/GameAntz/2.jpg").default,
      require("src/Assets/Images/Projects/GameAntz/3.jpg").default,
      require("src/Assets/Images/Projects/GameAntz/4.jpg").default,
      require("src/Assets/Images/Projects/GameAntz/5.jpg").default,
      require("src/Assets/Images/Projects/GameAntz/6.jpg").default,
    ],
  },
  {
    titleImg: require("src/Assets/Images/Projects/Kaito/1.jpg").default,
    title: "Project Kaito",
    para: `Anime inspired Nft art.`,
    link: "https://main.d3bb7dqy819dov.amplifyapp.com",
    imgs: [
      require("src/Assets/Images/Projects/Kaito/1.jpg").default,
      require("src/Assets/Images/Projects/Kaito/2.jpg").default,
      require("src/Assets/Images/Projects/Kaito/3.jpg").default,
    ],
  },
  {
    titleImg: require("src/Assets/Images/Projects/Elvantis/1.jpg").default,
    title: "Elvantis",
    para: `This is a blockchain based dapp for a crypto game and Nfts for Elvantis.`,
    imgs: [
      require("src/Assets/Images/Projects/Elvantis/1.jpg").default,
      require("src/Assets/Images/Projects/Elvantis/2.jpg").default,
      require("src/Assets/Images/Projects/Elvantis/3.jpg").default,
      require("src/Assets/Images/Projects/Elvantis/4.jpg").default,
      require("src/Assets/Images/Projects/Elvantis/5.jpg").default,
    ],
  },
  {
    titleImg: require("src/Assets/Images/Projects/Petoverse/1.jpg").default,
    title: "Petoverse",
    para: `This is a blockchain based dapp for a crypto game and Nfts for Petoverse.`,
    link: "https://www.petoverse.io/",
    imgs: [
      require("src/Assets/Images/Projects/Petoverse/1.jpg").default,
      require("src/Assets/Images/Projects/Petoverse/2.jpg").default,
      require("src/Assets/Images/Projects/Petoverse/3.jpg").default,
      require("src/Assets/Images/Projects/Petoverse/4.jpg").default,
      require("src/Assets/Images/Projects/Petoverse/5.jpg").default,
    ],
  },
  {
    titleImg: require("src/Assets/Images/Projects/PetoverseDashboard/1.jpg").default,
    title: "Petoverse Dashboard",
    para: `This is a blockchain based dapp for a crypto game called Petoverse.`,
    link: "https://petoverse-frontend.netlify.app/",
    imgs: [
      require("src/Assets/Images/Projects/PetoverseDashboard/1.jpg").default,
      require("src/Assets/Images/Projects/PetoverseDashboard/2.jpg").default,
      require("src/Assets/Images/Projects/PetoverseDashboard/3.jpg").default,
    ],
  },
  {
    titleImg: require("src/Assets/Images/Projects/Swippy/1.png").default,
    title: "Swippy",
    para: `This is a social links sharing app, here you can make a profile and add all your social links
    and share your profile link, There is also NFC tag functionality, just by touching someone else's NFC tag
    it will redirect to their profile or open specific social account as configured. Core technologies used are
    React-Redux and Firebase with authentication.`,
    link: "https://competent-jennings-aee101.netlify.app/",
    imgs: [
      require("src/Assets/Images/Projects/Swippy/1.png").default,
      require("src/Assets/Images/Projects/Swippy/2.png").default,
      require("src/Assets/Images/Projects/Swippy/3.png").default,
      require("src/Assets/Images/Projects/Swippy/4.png").default,
      require("src/Assets/Images/Projects/Swippy/5.png").default,
      require("src/Assets/Images/Projects/Swippy/6.png").default,
      require("src/Assets/Images/Projects/Swippy/7.png").default,
    ],
  },
  {
    titleImg: require("src/Assets/Images/Projects/NFTComics/1.png").default,
    title: "NFT-Comics",
    para: `This is a blockchain related nft web`,
    link: "https://hungry-kalam-cd5768.netlify.app/",
    imgs: [
      require("src/Assets/Images/Projects/NFTComics/1.png").default,
      require("src/Assets/Images/Projects/NFTComics/2.png").default,
      require("src/Assets/Images/Projects/NFTComics/3.png").default,
      require("src/Assets/Images/Projects/NFTComics/4.png").default,
      require("src/Assets/Images/Projects/NFTComics/5.png").default,
      require("src/Assets/Images/Projects/NFTComics/6.png").default,
      require("src/Assets/Images/Projects/NFTComics/7.png").default,
      require("src/Assets/Images/Projects/NFTComics/8.png").default,
      require("src/Assets/Images/Projects/NFTComics/9.png").default,
      require("src/Assets/Images/Projects/NFTComics/10.png").default,
    ],
  },
  {
    titleImg: require("src/Assets/Images/Projects/Novasoft/1.png").default,
    title: "Novasoft",
    para: `Website of my previous job organization, It is created by me on ReactJS.`,
    link: "https://novasoft.tech/",
    imgs: [
      require("src/Assets/Images/Projects/Novasoft/1.png").default,
      require("src/Assets/Images/Projects/Novasoft/2.png").default,
      require("src/Assets/Images/Projects/Novasoft/3.png").default,
      require("src/Assets/Images/Projects/Novasoft/4.png").default,
      require("src/Assets/Images/Projects/Novasoft/5.png").default,
    ],
  },
  {
    titleImg: require("src/Assets/Images/Projects/Fantopia/1.png").default,
    title: "Fantopia",
    para: `This is a blockchain related nft selling web`,
    // link: "https://competent-jennings-aee101.netlify.app/",
    imgs: [
      require("src/Assets/Images/Projects/Fantopia/1.png").default,
      require("src/Assets/Images/Projects/Fantopia/2.png").default,
      require("src/Assets/Images/Projects/Fantopia/3.png").default,
      require("src/Assets/Images/Projects/Fantopia/4.png").default,
      require("src/Assets/Images/Projects/Fantopia/5.png").default,
      require("src/Assets/Images/Projects/Fantopia/6.png").default,
      require("src/Assets/Images/Projects/Fantopia/7.png").default,
    ],
  },
  {
    titleImg: require("src/Assets/Images/Projects/DragEditor/1.png").default,
    title: "Drag-Editor",
    para: `This is a basic editing app, which has the ability to add images and stickers and text in different styles. All components
    are manipulated using MovableJS, and current artboard can be saved in JSON format and reloaded.`,
    link: "https://mystifying-bardeen-45fd62.netlify.app/",
    imgs: [
      require("src/Assets/Images/Projects/DragEditor/1.png").default,
      require("src/Assets/Images/Projects/DragEditor/2.png").default,
    ],
  },
  {
    titleImg: require("src/Assets/Images/Projects/Kelekshen/1.png").default,
    title: "Kelekshen",
    para: `A blockchain trading system, frontend developed on React JS, 
    with material ui core components and alot of custom desinged components 
    and modals. With a beautiful theme this website highlights my potential as a frontend dev.`,
    link: "https://kelekshen.netlify.app/",
    imgs: [
      require("src/Assets/Images/Projects/Kelekshen/1.png").default,
      require("src/Assets/Images/Projects/Kelekshen/2.png").default,
      require("src/Assets/Images/Projects/Kelekshen/3.png").default,
      require("src/Assets/Images/Projects/Kelekshen/4.png").default,
      require("src/Assets/Images/Projects/Kelekshen/5.png").default,
    ],
  },
  {
    titleImg: require("src/Assets/Images/Projects/RedditRedesign/1.jpg").default,
    title: "Reddit Redesign",
    para: `This is a fresh take on reddit like web app, Appleaing UI and nested commenting and posting functionality.
    Core technologies used are React-Redux and Firebase with authentication.`,
    link: "https://hardcore-carson-11d2eb.netlify.app/",
    imgs: [
      require("src/Assets/Images/Projects/RedditRedesign/1.jpg").default,
      require("src/Assets/Images/Projects/RedditRedesign/2.jpg").default,
      require("src/Assets/Images/Projects/RedditRedesign/3.jpg").default,
      require("src/Assets/Images/Projects/RedditRedesign/4.jpg").default,
    ],
  },
  {
    titleImg: require("src/Assets/Images/Projects/Shopian/1.png").default,
    title: "Shopian",
    para: `This is a fullstack application currently in development and one of the first sites which 
    i created using both React JS Material UI and Firebase backend.
    This app combines a materialistic ui with powerful backend provided by google firebase.`,
    link: "https://shopian-app.web.app/",
    imgs: [
      require("src/Assets/Images/Projects/Shopian/1.png").default,
      require("src/Assets/Images/Projects/Shopian/2.png").default,
      require("src/Assets/Images/Projects/Shopian/3.png").default,
      require("src/Assets/Images/Projects/Shopian/4.png").default,
      require("src/Assets/Images/Projects/Shopian/5.png").default,
    ],
  },
  {
    titleImg: require("src/Assets/Images/Projects/WalletTracker/1.png").default,
    title: "Wallet Tracker",
    para: `This is a fullstack app created with google firebase backend and pure HTML/CSS and Javascript.
    It's a wallet tracking app which you can signin in to keep track of your expenses and income very easily with a simple very easy to understand UI`,
    link: "https://wallet-tracker-js-ce5d2.web.app/",
    imgs: [
      require("src/Assets/Images/Projects/WalletTracker/1.png").default,
      require("src/Assets/Images/Projects/WalletTracker/2.png").default,
      require("src/Assets/Images/Projects/WalletTracker/3.png").default,
    ],
  },
  {
    titleImg: require("src/Assets/Images/Projects/SaqlainPrinters/1.png").default,
    title: "Saqlain Printers",
    para: `Website made with pure html/css and pure javascript animations.`,
    link: "https://saqlainprinters.web.app/",
    imgs: [
      require("src/Assets/Images/Projects/SaqlainPrinters/1.png").default,
      require("src/Assets/Images/Projects/SaqlainPrinters/2.png").default,
      require("src/Assets/Images/Projects/SaqlainPrinters/3.png").default,
      require("src/Assets/Images/Projects/SaqlainPrinters/4.png").default,
    ],
  },
  {
    titleImg: require("src/Assets/Images/Projects/MapkitJS/title.png").default,
    title: "Mapkit JS Impl",
    para: `Web app made with Apple's web Mapkit JS, with capabilities of adding pins and labeling them per user basis.
    User authentication using firebase auth and pins saving in firestore.`,
    link: "https://determined-kalam-e70242.netlify.app/",
    imgs: [
      require("src/Assets/Images/Projects/MapkitJS/1.png").default,
      require("src/Assets/Images/Projects/MapkitJS/2.png").default,
      require("src/Assets/Images/Projects/MapkitJS/3.png").default,
    ],
  },
  {
    titleImg: require("src/Assets/Images/Projects/commingsoon.png").default,
    title: "",
    para: ``,
    // link: "https://google.com",
    imgs: [
      require("src/Assets/Images/Projects/commingsoon.png").default,
      require("src/Assets/Images/Projects/commingsoon.png").default,
      require("src/Assets/Images/Projects/commingsoon.png").default,
    ],
  },
];

export const allSkills = [
  {
    title: "Frontend",
    skills: [
      "HTML",
      "CSS",
      "Javascript",
      "Typescript",
      "Tailwind",
      "React JS",
      "Next JS",
      "Redux",
      "Redux Toolkit",
      "React Router",
      "Module CSS",
      "MUI",
      "SocketIO",
      "Framer Motion",
      "Formik",
      "React Query",
      "React Spring",
      "React Native",
      "Expo",
      "Webpack",
      "WXT Chrome Extension",
    ],
  },
  {
    title: "Backend",
    skills: [
      "Node JS",
      "Nest JS",
      "BullMQ",
      "Express JS",
      "MongoDB",
      "PostgreSQL",
      "Passport JS",
      "Firebase",
      "Mongoose",
      "SocketIO",
      "REST API",
      "JWT",
    ],
  },
  {
    title: "Blockchain",
    skills: [
      "Solidity",
      "Viem",
      "Ethers JS",
      "Hardhat",
      "Smart Accounts",
      "Moralis",
      "LayerZero",
      "Infura",
      "The Graph",
      "Web3Auth",
      "ZeroDev",
      "Subgraph",
    ],
  },
  {
    title: "AI",
    skills: ["Google Agent Development Kit", "Python"],
  },
  {
    title: "DevOps",
    skills: [
      "FlyIO",
      "Heroku",
      "Netlify",
      "Railway",
      "Firebase",
      "Vercel",
      "Gcloud Basics",
      "Elastic Beanstalk",
      "Aws CodePipeline",
      "Aws Codebuild",
      "AWS EC2",
      "Azure VM",
      "AWS Amplify",
      "AWS Certificate Manager",
      "AWS S3",
      "Git",
      "Github",
      "Github Actions",
      "Turborepo",
    ],
  },
  {
    title: "Other",
    skills: ["Java", "C#", "MySQL", "Jira", "Trello", "Discord", "Asana", "Adobe Photoshop", "Adobe Illustrator"],
  },
];
